import {Component, OnInit} from '@angular/core';
import {NavService} from '../../../../_services/_nav.service';
import {FormGroup} from '@angular/forms';
import {forkJoin, Subscription} from 'rxjs';
import {UtilitiesService} from '../../../../utils/utilities.service';
import {SolicitudAhorrosService} from '../../../../_services/solicitud-ahorros.service';
import {TranslateService} from '@ngx-translate/core';
import {Message} from '@stomp/stompjs';
import {RxStompService} from '@stomp/ng2-stompjs';
import {AutenticacionService} from '../../../../_services/autenticacion.service';
import {ExcelAvance} from '../../../../_models/excel-avance';

@Component({
  selector: 'app-widget-solicitud-ahorro-pendiente',
  templateUrl: './widget-solicitud-ahorro-pendiente.component.html',
  styleUrls: ['./widget-solicitud-ahorro-pendiente.component.css']
})
export class WidgetSolicitudAhorroPendienteComponent implements OnInit {
  loading = true;
  loadingTable = false;
  contador: number;
  solicitudes: any[] = [];
  columnas: any[] = [];
  showModalSolicitudes = false;

  //Variables del datatable
  public numeroRegistros: number;

  //Paginacion
  page = '0';
  rowsPerPage = 10;
  rowsCount = 10;
  filtroLazy: {
    cantidad: number,
    pagina: number
  };
  listSolicitudes: any[] = [];
  formulario: FormGroup;
  modalVerificacion = {verificando: false, estActual: null, error: false, exitoso: 0};

  private topSubscription: Subscription;
  excelAvance: ExcelAvance;
  lanIntegracion = false;

  constructor(private navServicio: NavService,
              private solicitudAhorroService: SolicitudAhorrosService,
              public utilitiesService: UtilitiesService,
              private translateService: TranslateService,
              private rxStompService: RxStompService,
              private authService: AutenticacionService,) {
  }

  ngOnInit() {
    this.contador = 0;
    this.columnas = [
      {field: 'idSolicitudInterno', header: this.navServicio.buscarMensaje('WIDGETMODAL.LBL_NUMEROSOLICITUD'), sort: false, check: false},
      {field: 'fechasolicitud', header: this.navServicio.buscarMensaje('WIDGETMODAL.LBL_FECHASOLICITUD'), sort: false, check: false},
      {field: 'codigoTipoDocumento', header: this.navServicio.buscarMensaje('WIDGETMODAL.LBL_TIPODOCUMENTO'), sort: false, check: false},
      {field: 'numeroDocumento', header: this.navServicio.buscarMensaje('WIDGETMODAL.LBL_NUMERODOCUMENTO'), sort: false, check: false},
      {field: 'nombreEstado', header: this.navServicio.buscarMensaje('WIDGETMODAL.LBL_ESTADOSOLICITUD'), sort: false, check: false},
      {field: 'det', header: this.navServicio.buscarMensaje('LBL_ACCIONES'), sort: false, check: false}
    ];

    forkJoin(this.cargarContador()).subscribe(([totalPendientesShivan]) => {
      this.loading = false;
    });

    this.conectarSocket();
  }

  async cargarContador() {
    const pendientes = await this.solicitudAhorroService.countPendienteSolicitudAhorro().toPromise();
    this.contador = pendientes;
    console.log(this.contador);
    this.rowsPerPage = !this.contador || this.contador == 0 ? 10 : this.contador;
  }

  visualizarIntegracionesFallidas() {
    this.showModalSolicitudes = true;
    this.filter();
  }


  async filter(event: any = null) {
    this.loadingTable = true;
    if (event) {
      this.page = String(event.first / this.rowsPerPage);
    } else {
      this.page = '0';
    }

    const a = Object.assign({}, this.filtroLazy);
    a.pagina = Number(this.page);
    a.cantidad = this.rowsPerPage;

    this.solicitudAhorroService.solicitudesPendienteCuentasAhorro(a).subscribe(listaSolicitudes => {
      this.numeroRegistros = Number(listaSolicitudes.total);
      this.listSolicitudes = [];

      this.listSolicitudes = listaSolicitudes.data;
      this.loadingTable = false;
      if (this.listSolicitudes.length === 0) {
        this.navServicio.setMesage(0,
          {
            severity: 'info',
            summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
            detail: this.navServicio.buscarMensaje('WIDGETMODAL.MSG_NOEXISTENREGISTROS')
          });
      }

    }, error => {
      this.loadingTable = false;
      this.navServicio.setMesage(0,
        {
          severity: 'error',
          summary: this.navServicio.buscarMensaje('LBL_ERROR'),
          detail: this.navServicio.buscarMensaje('MSG_ERRORCARGAR')
        });
    });
  }


  async modalConfirmacion(solicitud: any) {
    const obj = {
      idSolicitud: solicitud.idSolicitud,
      numeroCuenta: solicitud.numeroCuenta
    };

    // Obtén las traducciones una vez, para evitar repetición en el código
    const mensajeActualizada = await this.translateService.get('WIDGETMODAL.MSG_CAMBIOSOLICITUD', {
      NUMSOLAHO: solicitud.idSolicitudInterno,
      value: 'actualizada'
    }).toPromise();
    const mensajeFallida = await this.translateService.get('WIDGETMODAL.MSG_CAMBIOSOLICITUD', {
      NUMSOLAHO: solicitud.idSolicitudInterno,
      value: 'fallida'
    }).toPromise();

    this.loading = true;

    this.solicitudAhorroService.aprobarSolicitudCuentaAhorro(obj).subscribe(
      data => {
        console.log(data);
        this.navServicio.setMesage(0, {
          severity: 'success',
          summary: this.navServicio.buscarMensaje('WIDGETMODAL.LBL_TITLESOLICITUDEXITOSO'),
          detail: mensajeActualizada
        });
      },
      error => {
        this.navServicio.setMesage(0, {
          severity: 'error',
          summary: this.navServicio.buscarMensaje('WIDGETMODAL.LBL_TITLESOLICITUDFALLIDA'),
          detail: mensajeFallida
        });
      },
      async () => {
        await this.cargarContador();
        // Este bloque siempre se ejecuta tanto en éxito como en error
        this.lanIntegracion = false;
        this.showModalSolicitudes = false;
        this.loading = false;
      }
    );
  }

  async cerrarVerificacion() {
    this.modalVerificacion.verificando = false;
    this.showModalSolicitudes = false;
    this.modalVerificacion.error = false;
    this.loading = true;
    await this.cargarContador();
    this.loading = false;
  }

  conectarSocket() {
    this.topSubscription = this.rxStompService.watch('/topic/aprobacionSolicitudAhorros' + this.authService.obtenerIdUsuarioLogueado()).subscribe(async (message: Message) => {
      const body = (message && message.body) ? JSON.parse(message.body) : null;
      if (body && this.excelAvance && this.excelAvance.uid === body.uid) {
        this.excelAvance.avance = body.avance;
        this.excelAvance.errores = body.errores ? body.errores : [];
        this.excelAvance.totalRegistros = body.totalRegistros;
        if ((this.excelAvance.avance * 100) >= 100) {
          this.modalVerificacion.estActual = 'FINVER';
          this.modalVerificacion.error = this.excelAvance.errores.length > 0;
          this.modalVerificacion.exitoso = this.excelAvance.totalRegistros - this.excelAvance.errores.length
        }
      }
    });
  }

  async enviarActualizar() {
    this.loading = true;
    await this.cargarContador();
    this.loading = false;
  }

  enviarActualizarTodo() {
    // Consumir servicio de verificacion de archivo
    if (this.lanIntegracion) {
      return;
    }
    this.lanIntegracion = true;
    this.solicitudAhorroService.verificarIntegracion().subscribe(data => {
      this.modalVerificacion.estActual = 'INIT';
      this.excelAvance = data;
      this.lanIntegracion = false;
      this.modalVerificacion.verificando = true;
      console.log(this.modalVerificacion);
    }, error => {
      this.navServicio.setMesage(0,
        {
          severity: 'error',
          summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
          detail: this.navServicio.buscarMensaje('WIDGETMODAL.MSG_ERRORINTEGRACIONES')
        });
      this.lanIntegracion = false;
    });
  }


}
